import { DataGrid, type DataGridProps, type GridValidRowModel } from '@shared/components';

import { columns, type QConfigGenerator } from './columns';

type QContentListTableProps<TRowModel extends GridValidRowModel> = Omit<
  DataGridProps<TRowModel>,
  'columns'
>;

export default function BaseQConfigGeneratorList(
  props: Readonly<QContentListTableProps<QConfigGenerator>>,
) {
  return (
    <DataGrid
      disableColumnMenu
      {...props}
      columns={columns}
      rowHeight={52}
      sx={(theme) => ({
        '--DataGrid-overlayHeight': '412px',
        '.MuiDataGrid-overlayWrapperInner': {
          display: 'flex',
        },
        minHeight: '712px',
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: 'none',
        '.MuiDataGrid-cell': {
          padding: theme.spacing(3),
          paddingBottom: theme.spacing(2.75),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.grey[100],
        },
      })}
    />
  );
}
